//
// ┌─────────────────────┐
// │ DO NOT EDIT BY HAND │
// └─────────────────────┘
//
// Generated by build.mjs in zinnia-icons
//
import { mapPropsToSvgProps, Props } from "../utils";
function IconMiscPieFill(iconProps: Props) {
  const props = mapPropsToSvgProps(iconProps);
  return <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}><path d="M2.0498 12.91C2.2798 15.22 3.3098 17.3 4.8398 18.88L9.8498 12.91H2.0498Z" fill="currentColor" /><path d="M19.1496 4.94L6.36963 20.17C7.96963 21.27 9.90963 21.91 11.9996 21.91C17.5096 21.91 21.9996 17.42 21.9996 11.91C21.9996 9.2 20.9096 6.74 19.1496 4.94Z" fill="currentColor" /><path d="M17.6298 3.65C16.0298 2.55 14.0898 1.91 11.9998 1.91C6.8198 1.91 2.5498 5.86 2.0498 10.91H11.5298L17.6298 3.65Z" fill="currentColor" /></svg>;
}
export default IconMiscPieFill;